import { useRef, useState } from 'react';
import { useTranslation } from '../../../context/ConfigContext';
import { Button } from '../../Button/Button';
import Icon from '../../Icon/Icon';
import { Icons } from '../../Icon/constants';
import { HTMLInputMapId } from '../constants';

type NaverMapAutoCompleteCityProps = {
  onChangePlace: (place: naver.maps.Service.ReverseGeocodeAddress) => void;
};

const NaverMapAutoCompleteCity = ({ onChangePlace }: NaverMapAutoCompleteCityProps) => {
  const [suggestions, setSuggestions] = useState<naver.maps.Service.ReverseGeocodeAddress[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);
  const t = useTranslation();

  const fetchSuggestions = async (query: string) => {
    if (!query) return;
    
    naver.maps.Service.geocode({ query }, (status, response) => {
      if (status === naver.maps.Service.Status.OK && response.v2.addresses) {
        setSuggestions(response.v2.addresses);
      } else {
        console.error('Geocode error:', status);
      }
    });
  };

  const handleSelectSuggestion = (place: naver.maps.Service.ReverseGeocodeAddress) => {
    setSuggestions([]); // Clear suggestions
    onChangePlace(place); // Pass selected place to parent handler
    if (inputRef.current) {
      inputRef.current.value = place.roadAddress || place.jibunAddress; // Update input with the selected address
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    fetchSuggestions(e.target.value);
  };

  const askUserLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        naver.maps.Service.reverseGeocode(
          {
            coords: new naver.maps.LatLng(latitude, longitude),
          },
          (status, response) => {
            if (status === naver.maps.Service.Status.OK && response.v2.address) {
              handleSelectSuggestion(response.v2.address);
            } else {
              alert(t('storelocator-popup-geoloc-authorized', {}, false));
            }
          }
        );
      },
      (err) => {
        console.error(err);
        alert(t('storelocator-popup-geoloc-authorized', {}, false));
      }
    );
  };

  return (
    <div className="sellers-page-filter-search">
      <div className="sellers-page-filter-search-cities">
        <input
          type="text"
          placeholder={t('storelocator-search-placeholder', {}, false)}
          id={HTMLInputMapId}
          ref={inputRef}
          className="map-input-cities"
          onChange={handleInputChange}
        />
        <Icon iconName={Icons.SEARCH} className="sellers-page-filter-search-cities-icon naver" />
        {suggestions.length > 0 && (
          <ul className="autocomplete-suggestions">
            {suggestions.map((place) => (
              <li style={{padding: 10, background: "#fff"}} key={place.roadAddress} onClick={() => handleSelectSuggestion(place)}>
                {place.roadAddress || place.jibunAddress}
              </li>
            ))}
          </ul>
        )}
      </div>
      <Button onClick={askUserLocation} label={t('Locate Nearby', {}, false)} />
    </div>
  );
};

export default NaverMapAutoCompleteCity;
